module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7et9S"))).then(() => parcelRequire('1iHdE'));